export default __webpack_public_path__ + "assets/c89cb2714a4be3006c76373b49a4aea0.svg";